import { Option } from 'funfix-core';
import React from 'react';
import { ANALYTICS_MODAL_INSTALL, ANALYTICS_MODAL_NO_INSTALL_PERMISSION } from '../../../../analytics/Sources';
import { foldInstallStatus, isInstallStatusLoading } from '../../../../records/InstallMode/InstallStatus';
import { getErrorDetails } from '../../../../utils/request-utils';
import CloseButton from '../common/CloseButton';
import ContactAdmin from '../common/ContactAdmin';
import ExternalMarketplaceLink from '../common/ExternalMarketplaceLink';
import InstallableAppAlreadyInstalledMessage from '../common/InstallableAppAlreadyInstalledMessage';
import InstallableAppFooter from '../common/InstallableAppFooter';
import NewInstallableAppPrivacyInformation from '../common/NewInstallableAppPrivacyInformation';
import DialogDefaultContent from './DialogDefaultContent';
import { jsx as _jsx } from "react/jsx-runtime";
const resolveDialogDefault =
// eslint-disable-next-line max-lines-per-function
_ref => {
  let {
    closeInstallDialog,
    context,
    defaultInstallMode,
    hostConfig,
    appDetailsFromSearchResponse,
    hostInfo,
    hostPricing,
    installApp,
    links,
    scopesLookup,
    mpacBaseUrl,
    onRendered,
    isInstallInProgress,
    forgeAppEgressAddresses,
    editions,
    selectedEditionType,
    setSelectedEditionType,
    isEditionChargedSeparatelyInSandbox,
    eligibleForFreeOnSandboxWithEditions,
    isEditionsSupported,
    eligibleOfferings,
    showEditions,
    appHasMultiInstanceEntitlement
  } = _ref;
  return {
    analyticsSourceModal: defaultInstallMode.installPermission.fold(() => ANALYTICS_MODAL_NO_INSTALL_PERMISSION, () => ANALYTICS_MODAL_INSTALL),
    content: /*#__PURE__*/_jsx(DialogDefaultContent, {
      hostPricing: hostPricing,
      installableApp: defaultInstallMode.installableApp,
      installedApp: defaultInstallMode.installedApp,
      links: links,
      appDetailsFromSearchResponse: appDetailsFromSearchResponse,
      scopesLookup: scopesLookup,
      mpacBaseUrl: mpacBaseUrl,
      onRendered: onRendered,
      forgeAppEgressAddresses: forgeAppEgressAddresses,
      editions: editions,
      eligibleOfferings: eligibleOfferings,
      selectedEditionType: selectedEditionType,
      setSelectedEditionType: setSelectedEditionType,
      isEditionChargedSeparatelyInSandbox: isEditionChargedSeparatelyInSandbox
    }),
    heading: "Add to ".concat(hostConfig.installationLocation),
    footerLeft: /*#__PURE__*/_jsx(ExternalMarketplaceLink, {
      context: context,
      marketplaceAppDetails: defaultInstallMode.installableApp.marketplaceAppDetails,
      links: links,
      showEditions: showEditions
    }),
    footerCenter: defaultInstallMode.installedApp.fold(() => defaultInstallMode.installPermission.fold(() => /*#__PURE__*/_jsx(ContactAdmin, {}), () => null), () => /*#__PURE__*/_jsx(InstallableAppAlreadyInstalledMessage, {
      hostConfig: hostConfig,
      installedApp: defaultInstallMode.installedApp
    })),
    privacyInformation: defaultInstallMode.installedApp.fold(() => defaultInstallMode.installPermission.fold(() => null, () => /*#__PURE__*/_jsx(NewInstallableAppPrivacyInformation, {
      context: context,
      installableAppId: defaultInstallMode.installableAppId,
      links: links,
      marketplaceAppDetails: defaultInstallMode.installableApp.marketplaceAppDetails
    })), () => null),
    footerRight: defaultInstallMode.installPermission.fold(_ => /*#__PURE__*/_jsx(CloseButton, {
      onClick: closeInstallDialog
    }), _ => /*#__PURE__*/_jsx(InstallableAppFooter, {
      closeInstallDialog: closeInstallDialog,
      context: context,
      hostConfig: hostConfig,
      installableAppInstallMode: defaultInstallMode,
      installApp: installApp,
      hostInfo: hostInfo,
      mpacBaseUrl: mpacBaseUrl,
      isInstallInProgress: isInstallInProgress,
      isEditionChargedSeparatelyInSandbox: isEditionChargedSeparatelyInSandbox,
      eligibleForFreeOnSandboxWithEditions: eligibleForFreeOnSandboxWithEditions,
      isEditionsSupported: isEditionsSupported,
      appHasMultiInstanceEntitlement: appHasMultiInstanceEntitlement,
      selectedEditionType: selectedEditionType
    })),
    preventDialogClosing: isInstallStatusLoading(defaultInstallMode.status),
    errorDetails: foldInstallStatus(defaultInstallMode.status, () => Option.empty(), () => Option.empty(), complete => complete.result.fold(error => Option.some(getErrorDetails(error, hostConfig)), () => Option.empty()))
  };
};
export default resolveDialogDefault;